@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.menu-toggle {
  width: 32px;

  border-radius: 6px;

  color: @settings-page--shipping-fulfilment-provider-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--shipping-fulfilment-provider-menu--hover--background-color;
    color: @settings-page--shipping-fulfilment-provider-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--shipping-fulfilment-provider-menu--active--background-color;
    color: @settings-page--shipping-fulfilment-provider-menu--active--text-color;
  }
}

.open-menu-toggle {
  background-color: @settings-page--shipping-fulfilment-provider-open-menu--background-color;
  color: @settings-page--shipping-fulfilment-provider-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}
